// import { GoogleLogin } from "@react-oauth/google";
// import axios from "axios";

// export default function LoginPopup({ onLogin }) {

//   const handleSuccess = async (res) => {
//     try {
// await axios.post(
//   `${process.env.REACT_APP_NAV_API}/auth/google`,
//   { credential: res.credential },
//   { withCredentials: true }
// );

// // ✅ small delay to ensure cookie is set
// setTimeout(() => {
//   onLogin();
// }, 300);



//     } catch (err) {
//       console.error("Login failed", err);
//     }
//   };

//   return (
//     <div style={{
//       height: "100vh",
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       background: "#f5f6fa"
//     }}>
//       <div style={{
//         padding: 30,
//         borderRadius: 12,
//         background: "#fff",
//         boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
//         textAlign: "center"
//       }}>
//         <h2>GEPL Dashboard</h2>
//         <p>Please sign in to continue</p>

//         <GoogleLogin
//           onSuccess={handleSuccess}
//           onError={() => console.log("Login Failed")}
//         />
//       </div>
//     </div>
//   );
// }

















import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";

export default function LoginPopup({ onLogin }) {

  const handleSuccess = async (res) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_NAV_API}/auth/google`,
        { credential: res.credential },
        { withCredentials: true }
      );

      setTimeout(() => {
        onLogin();
      }, 300);

    } catch (err) {
      console.error("Login failed", err);
    }
  };

  const logoUrl = "/logo.jpg";
  return (
    <div style={{ height: "100vh", background: "#f5f6fa" }}>

      {/* 🔹 HEADER */}
<div style={{
  background: "#143b7e",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",   // 👈 important
  padding: "10px 40px",
  boxShadow: "0 2px 10px rgba(0,0,0,0.05)"
}}>
  
  {/* 🔹 LEFT - LOGO */}
  <img 
    src={logoUrl} 
    alt="GEPL Logo" 
    style={{ height: "50px" }}
  />

  {/* 🔹 CENTER - TEXT */}
  <div style={{
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: "22px",
    fontWeight: "700",
    color: "#fff"
  }}>
    Welcome to GEPL Capital
  </div>

  {/* 🔹 RIGHT - EMPTY (for balance) */}
  <div style={{ width: "50px" }}></div>

</div>
      {/* 🔹 CENTER LOGIN BOX */}
      <div style={{
        height: "calc(100vh - 60px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <div style={{
          padding: "30px 30px",
          borderRadius: "16px",
          background: "#fff",
          boxShadow: "0 15px 40px rgba(0,0,0,0.1)",
          textAlign: "center",
          width: "350px"
        }}>



          <h2 style={{ marginBottom: "8px" }}>GEPL Dashboard</h2>
          <p style={{ marginBottom: "25px", color: "#666" }}>
            Please sign in to continue
          </p>

<div style={{
  display: "flex",
  justifyContent: "center",
  width: "100%"
}}>
  <GoogleLogin
    onSuccess={handleSuccess}
    onError={() => console.log("Login Failed")}
    width="250"   // 🔥 important
  />
</div>

        </div>
      </div>
    </div>
  );
}